// @flow

import * as React from 'react';

import type { ProductKind } from '@gandi/cart';

import * as Products from './components';

/**
 * Retrieve the Component in charge of the product according to the product type.
 * Fallback on Default.
 */
export const getProductComponent = (
  componentName: ProductKind,
): React.ComponentType<any> => {
  if (componentName in Products) {
    // $FlowFixMe[prop-missing]
    return Products[componentName];
  }

  if (global.__DEV__) {
    // eslint-disable-next-line no-console
    console.warn(
      `Product Component ${componentName} not found, fallback to Default.`,
    );
  }

  return Products.Default;
};
